
    import I18n from 'i18nObj';
    
      import 'translations/common';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('common');
  